import React from 'react';
import useFetch from "../../services/useFetch.js"
import MetricCard from '../ui/MetricCard';

export default function HighestMenuItem({ reload }) {
    const { data, load } = useFetch('api/menu-margin/highest', reload);

    return (
        <MetricCard
            label="Highest margin"
            loading={load}
            value={data?.profitMargin != null ? `${Number(data.profitMargin).toFixed(1)}%` : '—'}
            detail={data?.posMenuItem || 'No margin data'}
        />
    );
}
